import {
    InspectorEvent,
    ViewConfigPayload,
    WORKBENCH_VIEW_CONFIG,
    WorkbenchViewConfig
} from '../../../shared/types';
import {Component, Inject} from '@angular/core';
import {WorkbenchViewComponent} from '../../../shared/components/viewcontainers/workbench-view.component';
import {WorkbenchLayoutManager} from '../../../shared/services/workbench-layout-manager.service';
import {Artifact} from '@webmate-web-core/shared/types/artifact';
import {ArtifactId} from '@webmate-web-core/shared/types/ids';
import {TestMailService} from '../services/testmail.service';
import {distinctUntilChanged} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {WorkbenchCommandRegistry} from '../../../shared/services/workbench-command-registry.service';
import {InspectorService} from '../../../shared/services/inspector.service';

export interface MailViewConfig extends ViewConfigPayload {
    data: {
        mailId: ArtifactId;
    }
}

@UntilDestroy()
@Component({
    templateUrl: './mail-center-view.component.html',
    styleUrls: ['./mail-center-view.component.less']
})
export class MailCenterViewComponent extends WorkbenchViewComponent {

    mailId: ArtifactId;
    mail: Artifact;

    inspectorIsOpen:boolean = false;

    constructor(layoutManager: WorkbenchLayoutManager,
                private testMailService: TestMailService,
                @Inject(WORKBENCH_VIEW_CONFIG) public config: WorkbenchViewConfig<MailViewConfig>,
                private workbenchCommandRegistry: WorkbenchCommandRegistry,
                private inspectorService: InspectorService
                ) {
        super(layoutManager, config);
    }

    ngOnInit() {
        this.mailId = this.config.payload.data.mailId;
        this.testMailService.getMailArtifact(this.mailId).subscribe(mail => {
            this.mail = mail;
        });

        this.layoutManager.subscribeActiveViewId$().pipe(
            untilDestroyed(this), distinctUntilChanged()
        ).subscribe(activeView =>{
            if (activeView === this.viewId && !this.inspectorIsOpen){
                this.openMailInspector()
                this.inspectorIsOpen = true;
            }
            if (activeView !== this.viewId && this.inspectorIsOpen){
                this.closeMailInspector()
                this.inspectorIsOpen = false;
            }
        });
    }

    override beforeViewClose() {
        this.closeMailInspector();
    }

    openMailInspector(){
        // Use setTimeout to make sure the current mail is only enabled after all previous have been disabled
        setTimeout(() => {
            this.workbenchCommandRegistry.executeCommand("mail:openMailTools", {artifactId: this.mailId});
        }, 5)
    }

    closeMailInspector(){
        const event: InspectorEvent = {type: "ClearInspector"};
        this.inspectorService.raiseInspectorEvent(event);
    }
}